import { Select } from "flowbite-react";
import { useLocation } from "react-router-dom";
import { HistoryCard } from "../../layouts/fileUploader/historyCard";
import { UploadForm } from "./uploadForm";
import { createContext, useContext, useEffect, useState } from "react";
import CopyClipboard from "../../layouts/fileUploader/copyClipboard";
import { FilterOptions } from "../../helpers/fileUploader/objects";
import {
  C_DIVIDEND_FEED,
  C_GENERAL,
  C_LEGAL_DOCUMENTS,
} from "../../constants/types";
import { UploadContext } from "../../context/UploadProvider";
import ConditionalRender from "../../helpers/fileUploader/condtRender";
import FormType from "../../helpers/fileUploader/formType";
import { SUB_CATEGORY_CONFIG } from "../../helpers/fileUploader/subCategoryConfig";

export const StorageContext = createContext();

export const UploadSection = () => {
  const location = useLocation();
  const formType = FormType();
  const [subCategory, setSubCategory] = useState("");
  const config = SUB_CATEGORY_CONFIG[formType];

  const [filter, setFilter] = useState("all");
  const { data, isLoading } = useContext(UploadContext);

  useEffect(() => {
    setSubCategory(config ? config.getOptions()[0].value : "");
  }, [formType, config]);

  const handleSubCategory = (e) => setSubCategory(e.target.value);

  // to reset the filter value on state change
  useEffect(() => {
    setFilter("all");
  }, [location]);

  return (
    <StorageContext.Provider value={{ subCategory, isLoading }}>
      {/*   <ConditionalRender condition={[C_LEGAL_DOCUMENTS, C_GENERAL]}>
        <OutdatedFiles data={data} formType={formType} />
      </ConditionalRender> */}
      <div className="grid gap-2 grid-cols-1 lg:grid-cols-2 w-full ">
        <div className="w-full">
          <div className="flex gap-16">
            <h2 className="block mb-4 text-3xl font-bold tracking-tight text-secondary">
              Upload File
            </h2>

            <ConditionalRender condition={[C_LEGAL_DOCUMENTS]}>
              {config && (
                <Select
                  id="subCategory"
                  required={true}
                  defaultValue={config.getOptions()[0].value}
                  onChange={handleSubCategory}
                >
                  <option value="" disabled>
                    Choose here
                  </option>
                  {config.getOptions().map((item, index) => {
                    return (
                      <option key={index} value={item.value}>
                        {item.category}
                      </option>
                    );
                  })}
                </Select>
              )}
            </ConditionalRender>
          </div>

          <UploadForm formType={formType} />
        </div>
        <div className="w-full text-start">
          <div className="flex justify-between">
            <h2 className="block mb-4 text-3xl font-bold tracking-tight text-secondary">
              Upload History{" "}
              <ConditionalRender condition={[C_LEGAL_DOCUMENTS]}>
                <span className="bg-green-100 text-primary text-sm font-medium mr-2 px-2.5 py-0.5 rounded">
                  {subCategory}
                </span>
              </ConditionalRender>
            </h2>
            <ConditionalRender condition={[C_DIVIDEND_FEED]}>
              <CopyClipboard data={data} formType={formType} />
            </ConditionalRender>

            <ConditionalRender condition={[C_GENERAL, C_LEGAL_DOCUMENTS]}>
              <Select
                id="category"
                defaultValue={"all"}
                onChange={(e) => {
                  setFilter(e.target.value);
                }}
              >
                {FilterOptions().map((item, index) => {
                  return (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  );
                })}
              </Select>
            </ConditionalRender>
          </div>
          <HistoryCard data={data} formType={formType} filter={filter} />
        </div>
      </div>
    </StorageContext.Provider>
  );
};
